import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  type: {
    default: 'information',
    editor: 'dropdown',
    editorOptions: ['information', 'warning', 'danger', 'question'],
  },
  heading: {
    default: 'Transfer',
    editor: 'textbox',
  },
  text: {
    default: 'The transfer was successfully completed',
    editor: 'textbox',
  },
  width: {
    default: 'small',
    editor: 'dropdown',
    editorOptions: ['small', 'medium', 'large', 'full-screen'],
  },
  primaryButton: {
    default: 'Okey',
    editor: 'textbox',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A tag-message where you can change all the attributes',
  coreComponent: {
    html: `<tag-message{{...knobs}}>
</tag-message>
<tag-button id='btn'>Show</tag-button>`,
    js: `var btn = document.querySelector('#btn');
btn.addEventListener('click', function() {
  var dlg = document.querySelector('tag-message');
  dlg.show();
});`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper: {
    jsx: `<div>
<TagMessage{{...knobs}}/>
<TagButton
  text="Show"
  onButtonClick={() => document.querySelector('tag-message').show()}
/>
</div>`,
    knobs: PlaygroundKnobs,
  },
};

export const TagMessageDocs: Component = {
  type: 'component',
  name: 'message',
  description: 'Renders a message box',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'visible',
      type: 'boolean',
      description: 'Whether the dialog is shown',
    },
    {
      name: 'type',
      description: 'The type of dialog',
      type: `information' | 'danger' | 'warning' | 'question'`,
      default: 'information',
    },
    {
      name: 'heading',
      type: 'string',
      description: 'The heading text',
    },
    {
      name: 'text',
      type: 'string',
      description: 'The main body of text in the dialog',
    },
    {
      name: 'width',
      description: 'The width of the dialog',
      type: `'small' | 'medium' | 'large' | 'full-screen'`,
      default: 'medium',
    },
    {
      name: 'height',
      description: 'The height of the dialog',
      type: 'string',
    },
    {
      name: 'primaryButton',
      description:
        'The text for the primary button. If this is blank, no primary button will be displayed',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'opened',
      description: 'Raised when the dialog has opened',
      parameters: [],
    },
    {
      name: 'closed',
      description: 'Raised when the dialog closes',
      parameters: [],
    },
    {
      name: 'primaryButtonClick',
      description: 'Raised when the primary button is clicked',
      parameters: [],
    },
  ],
  methods: [
    {
      name: 'show',
      description: 'Shows the modal dialog',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'hide',
      description: 'Hides the modal dialog',
      parameters: [],
      returnType: 'void',
    },
  ],
  stories: [PlaygroundStory],
};
